module.exports = __webpack_public_path__ + "static/media/milesLoadedGradient.83c47366.svg";